import { createActionGroup, createReducer, createSelector, emptyProps, on, props } from '@ngrx/store';
import { IAppState } from '../index.state';
import { EntityAdapter, EntityState, createEntityAdapter } from '@ngrx/entity';
import { IUser, ISaveUser } from './user.model';
import { ICodeTitle } from 'ets-fe-ng-sdk';
export namespace UserStore {
  //#region STORE
  export interface IState extends EntityState<IUser> {}

  const adapter: EntityAdapter<IUser> = createEntityAdapter<IUser>({
    sortComparer: (a, b) => a.userName.localeCompare(b.userName),
    selectId: (i) => i.userName,
  });

  const initialState: IState = adapter.getInitialState();
  //#endregion

  //#region ACTIONS
  export const actions = {
    API: createActionGroup({
      source: 'User API',
      events: {
        create: props<{ item: ISaveUser }>(),
        createError: props<{ error: any }>(),
        createSuccess: props<{ result: IUser }>(),
        fetchAll: emptyProps(),
        fetchAllReset: emptyProps(),
        fetchAllError: props<{ error: any }>(),
        fetchAllSuccess: props<{ result: IUser[] }>(),
        fetchSingle: props<{ username: string }>(),
        fetchSingleError: props<{ error: any }>(),
        fetchSingleSuccess: props<{ result: IUser }>(),
        update: props<{ item: ISaveUser }>(),
        updateError: props<{ error: any }>(),
        updateSuccess: props<{ result: IUser }>(),
      },
    }),
  };
  //#endregion

  //#region SELECTORE
  export namespace selectors {
    const select = (state: IAppState) => state.user;
    export const selectAll = createSelector(select, adapter.getSelectors().selectAll);
    export const selectAllForInput = createSelector(
      selectAll,
      (list) =>
        list.map<ICodeTitle>((x) => ({
          code: x.userName,
          title: x.userName,
        })) || [],
    );
    export const selectAllMap = createSelector(select, adapter.getSelectors().selectEntities);
  }
  //#endregion

  //#region REDUCER
  export const reducer = createReducer(
    initialState,
    on(actions.API.fetchAllSuccess, (state, { result: items }) => {
      return adapter.setAll(items, state);
    }),
    // on(
    //   AuthActions.AuthAPI.loginSuccess,
    //   (state, { user, token }): AuthState.IState => ({ ...state, token, user }),
    // ),
    // on(AuthActions.logout, (state): AuthState.IState => ({ ...state, token: undefined, user: undefined })),
  );
  //#endregion
}
